import React from 'react'
import { useTranslation } from 'react-i18next'

import ModalDialog from '@components/ModalDialog/ModalDialog'
import Button from '@components/Button/Button'

import './EditionSwitchConfirmModal.scss'

export type EditionSwitchConfirmModalProps = {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function EditionSwitchConfirmModal({ visible, onCancel, onConfirm }: EditionSwitchConfirmModalProps) {
  const { t } = useTranslation('Editions')

  return (
    <ModalDialog
      visible={visible}
      onClose={onCancel}
      title={t('confirm.title')}
      bodyText={t('confirm.body')}
      extraClass="EditionSwitchConfirmModal"
      footerComponent={
        <div className="EditionSwitchConfirmModal-actions">
          <button type="button" className="EditionSwitchConfirmModal-cancel" onClick={onCancel}>
            <strong>{t('confirm.cancel')}</strong>
          </button>
          <Button onClick={onConfirm}>{t('confirm.confirm')}</Button>
        </div>
      }
    />
  )
}

export default EditionSwitchConfirmModal
